import React from "react";
import { FormattedMessage } from "react-intl";
import { MessageBanner } from "@folio/stripes/components";
/** National Library contacts page for publishers that already received an ISBN/ISMN. */
export var NK_CONTACTS_URL = "https://info-recek.nkp.cz/uzitecne-kontakty";
/**
 * Always-visible warning at the top of the publisher registration form: publishers that already
 * received an ISBN/ISMN should contact the agency directly instead of registering again.
 */
export var RegistrationContactNotice = function () { return (React.createElement(MessageBanner, { type: "warning" },
    React.createElement("strong", null,
        React.createElement(FormattedMessage, { id: "stripes-core.publishers.register.contactNotice", values: {
                link: function (chunks) { return (React.createElement("a", { href: NK_CONTACTS_URL, target: "_blank", rel: "noopener noreferrer" }, chunks)); },
            } })))); };
